import type {useCompanyStore} from '@/stores/company'

// const allowedFederalStates = ['Tirol', 'Salzburg', 'Bayern', 'Mecklenburg-Vorpommern', 'Wallis']

export function isUpsellingVisible(_companyStore: ReturnType<typeof useCompanyStore>) {
  return false
  // return (
  //   companyStore.attributes?.country === 'südtirol' ||
  //   !!(companyStore.federalState && allowedFederalStates.includes(companyStore.federalState))
  // )
}
